<template>
  <div>
    <a-modal v-model="visible" :confirmLoading="loading" :maskClosable="false" @cancel="cancel" @ok="confirm">
      <div slot="title">{{form.id ? '编辑会员类型' : '新增会员类型' }}</div>
      <div>
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="name" label="名称">
            <a-input v-model="form.name" />
          </a-form-model-item>
          <a-form-model-item prop="price" label="活动价">
            <a-input v-model="form.price" />
          </a-form-model-item>
          <a-form-model-item prop="ori_price" label="原价">
            <a-input v-model="form.ori_price" />
          </a-form-model-item>
          <a-form-model-item prop="h_date" label="赠送天数">
            <a-input v-model="form.h_date" />
          </a-form-model-item>
          <a-form-model-item prop="e_date" label="会员天数">
            <a-input v-model="form.e_date" />
          </a-form-model-item>
          <a-form-model-item prop="c_amt" label="会员金额">
            <a-input v-model="form.c_amt" />
          </a-form-model-item>
          <a-form-model-item prop="c_num" label="持股个数">
            <a-input v-model="form.c_num" />
          </a-form-model-item>
          <a-form-model-item prop="content" label="策略描述">
            <a-input v-model="form.content" />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { memberTypeCreate, memberTypeUpdate } from '@/api/member'
import rules from './rules.js'

export default {
  name: 'FormModal',
  props: ['visible', 'form', 'roleItems'],
  model: { prop: 'visible', event: 'cancel' },
  data () {
    return {
      rules,
      loading: false,
    };
  },
  methods: {
    confirm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          let func = this.form.id ? memberTypeUpdate : memberTypeCreate;
          func(this.form).then(data => {
            if (data.code==0){
            this.$message.success(data.msg);
            this.$emit(this.form.id ? 'update' : 'create', data);
            this.cancel();
            this.$parent.list();
            } else{
              this.$message.error(data.msg);
            }
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    cancel () {
      this.$emit('cancel', false);
      this.$refs.form.resetFields();
    },
  },
}
</script>

<style scoped>
</style>